module.exports = __webpack_public_path__ + "static/media/york-19.497f12da.jpg";